export default __webpack_public_path__ + "static/media/MOTO_AMAZON_500_330x330.c34757b9.png";